import { render, staticRenderFns } from "./examinxq.vue?vue&type=template&id=10d35da4&scoped=true"
import script from "./examinxq.vue?vue&type=script&lang=js"
export * from "./examinxq.vue?vue&type=script&lang=js"
import style0 from "./examinxq.vue?vue&type=style&index=0&id=10d35da4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d35da4",
  null
  
)

export default component.exports